"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocalize = void 0;
const format_datetime_1 = require("./components/format-datetime");
const format_money_1 = require("./components/format-money");
const format_number_1 = require("./components/format-number");
const format_percentage_1 = require("./components/format-percentage");
const context_1 = require("./context/context");
const format_datetime_2 = require("./format-datetime/format-datetime");
const format_money_2 = require("./format-money/format-money");
const format_number_2 = require("./format-number/format-number");
const format_percentage_2 = require("./format-percentage/format-percentage");
__exportStar(require("./get-currency-symbol/get-currency-symbol"), exports);
function createLocalize(config) {
    return {
        LocalizeProvider: context_1._LocalizeProvider,
        formatDateTime: (0, format_datetime_2.createFormatDatetime)(config),
        formatNumber: (0, format_number_2.createFormatNumber)(config),
        formatPercentage: (0, format_percentage_2.createFormatPercentage)(config),
        formatMoney: (0, format_money_2.createFormatMoney)(config),
        FormatDateTime: (0, format_datetime_1.createFormatDatetimeComponent)(config),
        FormatNumber: (0, format_number_1.createFormatNumberComponent)(config),
        FormatPercentage: (0, format_percentage_1.createFormatPercentageComponent)(config),
        FormatMoney: (0, format_money_1.createFormatMoneyComponent)(config),
        useFormatDateTime: (0, format_datetime_2.createUseFormatDatetime)(config),
        useFormatNumber: (0, format_number_2.createUseFormatNumber)(config),
        useFormatPercentage: (0, format_percentage_2.createUseFormatPercentage)(config),
        useFormatMoney: (0, format_money_2.createUseFormatMoney)(config),
        useLocaleConfig: (0, context_1.getLocaleConfigHook)(config),
    };
}
exports.createLocalize = createLocalize;
